<template>
    <div>
        <div class="hot">
            <div class="menu">
                <div class="item" :id="menu.id" v-for="(menu, index) in hotMenus" :key="menu.id" @click="goToMenu(menu)" :class="{odd: hotMenus.length % 2}" :style="hotStyle(index)">
                    <div class="content" :style="{ 'background-image': 'url(' + menu.icon + ')' }">
                        <div class="cover"></div>
                        <div class="name">{{ menu.name }}</div>
                        <div class="text">{{ menu.slogan }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom">
            <div class="title">自訂服務</div>
            <div class="menu">
                <div class="item" :id="menu.id" v-for="menu in customMenus" :key="menu.id" @click="goToMenu(menu)">
                    <div class="content">
                        <img :src="menu.icon" :alt="menu.name">
                        <div class="name">{{ menu.name }}</div>
                    </div>
                    <div class="text">
                        {{ menu.slogan }}
                    </div>
                </div>
            </div>
        </div>
        <div class="shops" v-if="shopMenus.length">
            <div class="title">
                精選店家
                <div class="keep" @click="goToFavorite">收藏 <img src="@/assets/img/menu/keep.svg"></div>
            </div>
            <div class="menu">
                <div class="item" :id="menu.id" v-for="menu in shopMenus" :key="menu.id" @click="goToMenu(menu)">
                    <div class="content">
                        <img :src="menu.icon" :alt="menu.name">
                        <div class="name">{{ menu.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Menu',
        computed: {
            shopMenus() {
                return this.menus.filter(menu => !['buy', 'transport', 'elastic', 'wait', 'pay', 'housekeeping', 'accompanying'].includes(menu.type) && !menu.is_hot);
            },
            customMenus() {
                return this.menus.filter(menu => ['buy', 'transport', 'elastic', 'wait', 'pay', 'housekeeping', 'accompanying'].includes(menu.type));
            },
            hotMenus() {
                return this.menus.filter(menu => !['buy', 'transport', 'elastic', 'wait', 'pay', 'housekeeping', 'accompanying'].includes(menu.type) && menu.is_hot);
            },
            ...mapGetters(['menus']),
        },
        methods: {
            hotStyle(index) {
                let radius = '0';

                if (this.hotMenus.length === 1) {
                    radius = '5px 5px 5px 5px';
                } else if (this.hotMenus.length === 2 && index === 0) {
                    radius = '5px 0 0 5px';
                } else if (this.hotMenus.length === 2 && index === 1) {
                    radius = '0 5px 5px 0';
                } else if (this.hotMenus.length > 2 ) {
                    if (index === 0) {
                        radius = '5px 0 0 0';
                    }

                    if (index === 1) {
                        radius = '0 5px 0 0';
                    }

                    if (this.hotMenus.length % 2) {
                        if (index === this.hotMenus.length - 1) {
                            radius = '0 0 5px 5px';
                        }
                    } else {
                        if (index === this.hotMenus.length - 1) {
                            radius = '0 0 5px 0';
                        } else if (index === this.hotMenus.length - 2) {
                            radius = '0 0 0 5px';
                        }
                    }
                }

                return {
                    borderRadius: radius,
                    overflow: 'hidden',
                };
            },
            goToMenu(menu) {
                if (menu.type === 'url') {
                    window.open(menu.target, '_blank');

                    return;
                }

                let to = { name: 'buy' };
                if (menu.type === 'pay') to = { name: 'pay' };
                if (menu.type === 'buy') to = { name: 'buy' };
                if (menu.type === 'transport') to = { name: 'transport' };
                if (menu.type === 'elastic') to = { name: 'elastic' };
                if (menu.type === 'wait') to = { name: 'wait' };
                if (menu.type === 'shops') to = { name: 'ShopList', query: { escrow: 1 } };
                if (menu.type === 'shops-self') to = { name: 'ShopList', query: { title: menu.name, self: 1 } };
                if (menu.type === 'shop') to = { name: 'shop', params: { id: menu.target } };
                if (menu.type === 'category') to = { name: 'ShopList', query: { title: menu.name, onlyCategory: menu.target } };
                if (menu.type === 'favorite') to = { name: 'ShopList', query: { title: menu.name, favorite: 1}};
                if (menu.type === 'wash') to = { name: 'wash' };
                if (menu.type === 'liquor') to = { name: 'liquorShop', params: { id: menu.target } };
                if (menu.type === 'housekeeping') to = { name: 'housekeeping' };
                if (menu.type === 'accompanying') to = { name: 'accompanying' };
                this.$router.push(to);
            },
            goToFavorite() {
                this.$router.push({ name: 'ShopList', query: { title: '我的收藏', favorite: 1}});
            }
        }
    };
</script>

<style lang="scss" scoped>
    .menu {
        margin: 20px 10px 0 10px;
        display: flex;
        flex-wrap: wrap;

        .item {
            margin: 5px;
            box-shadow: 0 1px 2px 0 rgba(0,0,0,0.25);
            border-radius: 6.02px;
            background-color: #FFFFFF;
            position: relative;
            cursor: pointer;

            .content {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                padding: 10px;

                img {
                    width: auto;
                    height: 50px;
                }

                .name {
                    color: #257D25;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 18px;
                    text-align: center;
                }
            }
        }
    }

    .hot {
        .menu {
            margin: 5px 10px 0 10px;
        }

        .item {
            flex: 0 0 calc(50% - 10px);

            .cover {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0,0,0,0.4);
                z-index: 0;
            }

            &.odd {
                &:last-child {
                    flex: 0 0 calc(100% - 10px);

                    .cover {
                        background: linear-gradient(90deg, rgba(0, 0, 0, .5) 40%, transparent 100%);
                    }
                }
            }



            .content {
                background-position: 50% 50%;
                background-size: cover;
                background-repeat: no-repeat;
                display: flex;
                align-items: flex-start;
                padding: 15px 20px;
                min-height: 80px;

                .name {
                    color: #FFFFFF;
                    font-size: 20px;
                    font-weight: 600;
                    letter-spacing: 2.33px;
                    line-height: 28px;
                    height: 28px;
                    z-index: 9;
                }

                .text {
                    margin-top: 10px;
                    color: #FFFFFF;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 18px;
                    z-index: 9;
                }
            }
        }
    }

    .custom {
        .item {
            flex: 0 0 calc(50% - 10px);
            margin: 9px 5px;

            .content {
                flex-direction: row;
                height: fit-content;

                .name {
                    color: #4A4A4A;
                }

                img {
                    width: auto;
                    height: 50px;
                    max-height: 100%;
                    margin-right: 3px;
                }
            }

            .text {
                height: 17px;
                width: 100%;
                color: #9B9B9B;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 17px;
                text-align: center;
                margin-bottom: 10px;
            }
        }
    }

    .shops {
        .menu {
            margin: 20px 10px 10px 10px;
        }

        .item {
            position: relative;
            .content {
                position: absolute;
                .name {
                    font-size: 13px;
                }
            }
        }
    }

    .title {
        color: #4A4A4A;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 22px;
        margin-top: 40px;
        position: relative;

        .keep {
            position: absolute;
            right: 15px;
            top: calc(50% - 10px);
            background-color: #339933;
            border-radius: 12px;
            padding: 2px 10px;
            color: #FFFFFF;
            font-size: 13px;
            letter-spacing: 0;
            line-height: 18px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    @media screen and (max-width: 230px) {
        .shops {
            .item {
                flex: 0 0 calc(100% - 10px);
                padding-bottom: calc(100% - 10px);
            }
        }
    }

    @media screen and (min-width: 231px) and (max-width: 345px) {
        .shops {
            .item {
                flex: 0 0 calc(50% - 10px);
                padding-bottom: calc(50% - 10px);
            }
        }
    }

    @media screen and (min-width: 346px) and (max-width: 374px) {
        .shops {
            .item {
                flex: 0 0 calc(33% - 10px);
                padding-bottom: calc(33% - 10px);
            }
        }
    }

    @media screen and (min-width: 375px) {
        .shops {
            .item {
                flex: 0 0 calc(25% - 10px);
                padding-bottom: calc(25% - 10px);
            }
        }
    }

</style>
